module.exports = __webpack_public_path__ + "img/status5.01927ceb.png";